export default {
	formatXML1450: [
		{
			TargetName: 'Thẻ Hdon\\DLHDon\\TTChung',
			IsTitle: true
		},
		{
			TargetName: 'Phiên bản XML',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên hóa đơn',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu hóa đơn',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số hóa đơn',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã hồ sơ',
			TagName: 'MHSo',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp là hóa đơn đề nghị cấp mã của Cơ quan thuế theo từng lần phát sinh)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày lập',
			TagName: 'NLap',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số bảng kê (Số của bảng kê các loại hàng hóa, dịch vụ đã bán kèm theo hóa đơn)',
			TagName: 'SBKe',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày bảng kê (Ngày của bảng kê các loại hàng hóa, dịch vụ đã bán kèm theo hóa đơn)',
			TagName: 'NBKe',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Đơn vị tiền tệ',
			TagName: 'DVTTe',
			MaxLength: 3,
			DataType: 'Chuỗi ký tự (Chi tiết tại Khoản 2, Mục IV, Phần I Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tỷ giá',
			TagName: 'TGia',
			MaxLength: '7,2',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp Đơn vị tiền tệ là VND)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Hình thức thanh toán',
			TagName: 'HTTToan',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã số thuế tổ chức cung cấp giải pháp hóa đơn điện tử',
			TagName: 'MSTTCGP',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (trừ trường hợp lập hóa đơn điện tử có mã không thu tiền trên Cổng thông tin điện tử của Cơ quan thuế)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã số thuế đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'MSTDVNUNLHDon',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'TDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Địa chỉ đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'DCDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế',
			IsTitle: true,
			PathRoot: 'Thẻ Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tính chất hóa đơn',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Số (1: Thay thế, 2: Điều chỉnh)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Loại hóa đơn có liên quan (Loại hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục VI kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn có liên quan (Ký hiệu mẫu số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16, Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu hóa đơn có liên quan (Ký hiệu hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Số hóa đơn có liên quan (Số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ngày lập hóa đơn có liên quan (Ngày lập hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'NLHDCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ghi chú',
			TagName: 'GChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Thẻ Hdon\\DLHDon\\NDHDon\\NBan',
			IsTitle: true,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Fax',
			TagName: 'Fax',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Website',
			TagName: 'Website',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua',
			IsTitle: true,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã khách hàng',
			TagName: 'MKHang',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Họ và tên người mua hàng',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Thẻ Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu',
			IsTitle: true,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tính chất',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục IV kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Số thứ tự',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Mã hàng hóa, dịch vụ',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Tên hàng hóa, dịch vụ',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Đơn vị tính',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Số lượng',
			TagName: 'SLuong',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Đơn giá',
			TagName: 'DGia',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName:
				'Tỷ lệ % chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'TLCKhau',
			MaxLength: '6,4',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName:
				'Số tiền chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'STCKhau',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Thành tiền (Thành tiền chưa có thuế GTGT)',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp TChat có giá trị là “4- Ghi chú/diễn giải”)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Thuế suất (Thuế suất thuế GTGT)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 17 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Thẻ HdonVDLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat',
			IsTitle: true,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Thuế suất (Thuế suất thuế GTGT)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 17 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HdonVDLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Thành tiền (Thành tiền chưa có thuế GTGT)',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HdonVDLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Tiền thuế (Tiền thuế GTGT)',
			TagName: 'TThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HdonVDLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Thẻ Hdon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true,
			PathRoot: 'Thẻ HdonVDLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Tổng tiền chưa thuế (Tổng cộng thành tiền chưa có thuế GTGT)',
			TagName: 'TgTCThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng giảm trừ không chịu thuế',
			TagName: 'TGTKCThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thuế (Tổng cộng tiền thuế GTGT)',
			TagName: 'TgTThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Thẻ Hdon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi',
			IsTitle: true,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tên loại phí',
			TagName: 'TLPhi',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
		},
		{
			TargetName: 'Tiền phí',
			TagName: 'TPhi',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
		},
		{
			TargetName: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
		},
		{
			TargetName: 'Tổng tiền chiết khấu thương mại',
			TagName: 'TTCKTMai',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng giảm trừ khác',
			TagName: 'TGTKhac',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng số',
			TagName: 'TgTTTBSo',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng chữ',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code',
			IsTitle: true,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Dữ liệu QR Code',
			TagNameCheck: 'DLQRCode',
			MaxLength: 512,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName: 'Mã của cơ quan thuế',
			TagName: 'MCCQT',
			MaxLength: 34,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)'
		},
		{
			TargetName: 'Thẻ Hdon\\DSCKS\\NBan',
			IsTitle: true,
			PathRoot:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)'
		},
		{
			TargetName: 'Chữ ký số người bán',
			TagName: 'Signature',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DSCKS\\NBan'
		},
		{
			TargetName: 'Thẻ Hdon\\DSCKS\\NMua',
			IsTitle: true,
			PathRoot: 'Thẻ Hdon\\DSCKS\\NBan'
		},
		{
			TargetName: 'Chữ ký số người mua',
			TagName: 'Signature',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DSCKS\\NMua'
		},
		{
			TargetName:
				'Với hóa đơn điện tử đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về hóa đơn điện tử và bổ sung thẻ CQT (đặt bên trong thẻ HDonXDSCKS) chứa thông tin chữ ký số của Cơ quan thuế (ký trên thẻ HDon\\DLHDon, thẻ HDon\\MCCQT và thẻ HDon\\DSCKS\\CQT\\Signature\\Object)',
			IsTitle: true,
			PathRoot: 'Thẻ Hdon\\DSCKS\\NMua'
		},
		{
			TargetName: 'Chữ ký số cơ quan thuế',
			TagName: 'Signature',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Với hóa đơn điện tử đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về hóa đơn điện tử và bổ sung thẻ CQT (đặt bên trong thẻ HDonXDSCKS) chứa thông tin chữ ký số của Cơ quan thuế (ký trên thẻ HDon\\DLHDon, thẻ HDon\\MCCQT và thẻ HDon\\DSCKS\\CQT\\Signature\\Object)'
		}
	],

	formatXMLBanHang: [
		{
			TargetName: 'Thẻ HDon\\DLHDon\\TTChung',
			IsTitle: true,
			PathRoot: ''
		},
		{
			TargetName: 'Phiên bản XML',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên hóa đơn',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu hóa đơn',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số hóa đơn',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã hồ sơ',
			TagName: 'MHSo',
			MaxLength: 20,
			DataType: 'Chuỗi ký tư',
			Constraint:
				'Bắt buộc (Đối với trường hợp là hóa đơn đề nghị cấp mã của Cơ quan thuế theo từng lần phát sinh )',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày lập',
			TagName: 'NLap',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Hóa đơn dành cho khu phi thuế quan (Hóa đơn dành cho tổ chức, cá nhân trong khu phi thuế quan)',
			TagName: 'HDDCKPTQuan',
			MaxLength: 1,
			DataType:
				'Số (1-Hóa đơn dành cho tổ chức, cá nhân trong khu phi thuế quan, 0-Hóa đơn không dành cho tổ chức, cá nhân trong khu phi thuế quan)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số bảng kê (Số của bảng kê các loại hàng hóa, dịch vụ đã bán kèm theo hóa đơn)',
			TagName: 'SBKe',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày bảng kê (Ngày của bảng kê các loại hàng hóa, dịch vụ đã bán kèm theo hóa đơn)',
			TagName: 'NBKe',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Đơn vị tiền tệ',
			TagName: 'DVTTe',
			MaxLength: 3,
			DataType: 'Chuỗi ký tự (Chi tiết tại Khoản 2, Mục IV, Phần I Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tỷ giá',
			TagName: 'TGia',
			MaxLength: '7,2',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp Đơn vị tiền tệ là VND)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Hình thức thanh toán',
			TagName: 'HTTToan',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã số thuế tổ chức cung cấp giải pháp hóa đơn điện tử',
			TagName: 'MSTTCGP',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (trừ trường hợp lập hóa đơn điện tử có mã không thu tiền trên Cổng thông tin điện tử của Cơ quan thuế)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã số thuế đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'MSTDVNUNLHDon',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'TDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Địa chỉ đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'DCDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tính chất hóa đơn',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Số (1: Thay thế, 2: Điều chỉnh)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Loại hóa đơn có liên quan (Loại hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục VI kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn có liên quan (Ký hiệu mẫu số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu hóa đơn có liên quan (Ký hiệu hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Số hóa đơn có liên quan (Số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ngày lập hóa đơn có liên quan (Ngày lập hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'NLHDCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ghi chú',
			TagName: 'GChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan',
			IsTitle: true,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Fax',
			TagName: 'Fax',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Website',
			TagName: 'Website',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã đơn vị quan hệ ngân sách',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã khách hàng',
			TagName: 'MKHang',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Căn cước công dân',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số hộ chiếu',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Họ và tên người mua hàng',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tính chất',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục IV kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số thứ tự',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Mã hàng hóa, dịch vụ',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tên hàng hóa, dịch Vụ',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn vị tính',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số lượng',
			TagName: 'SLuong',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn giá',
			TagName: 'DGia',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tỷ lệ % chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'TLCKhau',
			MaxLength: '6,4',
			DataType: 'Số',
			Constraint: 'Không Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Số tiền chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'STCKhau',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thành tiền',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp TChat có giá trị là “4-Ghi chú/diễn giải”)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\Ttoan',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Ttoan'
		},
		{
			TargetName: 'Tên loại phí',
			TagName: 'TLPhi',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Tiền phí',
			TagName: 'TPhi',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Tổng tiền chiết khấu thương mại',
			TagName: 'TTCKTMai',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng giảm trừ khác',
			TagName: 'TGTKhac',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng số',
			TagName: 'TgTTTBSo',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng chữ',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code',
			IsTitle: true,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Dữ liệu QR Code',
			MaxLength: 512,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của Cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName: 'Mã của cơ quan thuế',
			TagName: 'MCCQT',
			MaxLength: 34,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của Cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\NBan',
			IsTitle: true,
			PathRoot:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của Cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)'
		},
		{
			TargetName: 'Chữ ký số người bán',
			TagName: 'Signature',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\NBan'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\NMua',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DSCKS\\NBan'
		},
		{
			TargetName: 'Chữ ký số người mua',
			TagName: 'Signature',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\NMua'
		},
		{
			TargetName:
				'Với hóa đơn điện tử đủ điều kiện cấp mã, hệ thống của cơ quan thuế trả về hóa đơn điện tử và bổ sung thẻ CQT (đặt bên trong thẻ HDon\\DSCKS) chứa thông tin chữ ký số của Cơ quan thuế (ký trên thẻ HDon\\DLHDon, thẻ HDon\\MCCQT và thẻ HDon\\DSCKS\\CQT\\Signature\\Object)',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DSCKS\\NMua'
		},
		{
			TargetName: 'Chữ ký số cơ quan thuế',
			TagName: 'Signature',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Với hóa đơn điện tử đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về hóa đơn điện tử và bổ sung thẻ CQT (đặt bên trong thẻ HDon\\DSCKS) chứa thông tin chữ ký số của Cơ quan thuế (ký trên thẻ HDon\\DLHDon, thẻ HDon\\MCCQT và thẻ HDon\\DSCKS\\CQT\\Signature\\Object)'
		}
	],

	formatXMLMTT: [
		{
			TargetName: 'Thẻ HDon\\DLHDon\\TTChung',
			IsTitle: true
		},
		{
			TargetName: 'Phiên bản XML',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên hóa đơn',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu hóa đơn',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số hóa đơn',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày lập',
			TagName: 'NLap',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế',
			IsTitle: true
		},
		{
			TargetName: 'Tính chất hóa đơn',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Số (1: Thay thế, 2: Điều chỉnh)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Loại hóa đơn có liên quan (Loại hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục VI kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn có liên quan (Ký hiệu mẫu số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu hóa đơn có liên quan (Ký hiệu hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Số hóa đơn có liên quan (Số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ngày lập hóa đơn có liên quan (Ngày lập hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'NLHDCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Họ và tên người mua hàng',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã đơn vị quan hệ ngân sách',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Căn cước công dân',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số hộ chiếu',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu',
			IsTitle: true
		},
		{
			TargetName: 'Tính chất',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục IV kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Số thứ tự',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Mã hàng hóa, dịch vụ',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Tên hàng hóa, dịch vụ',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Đơn vị tính',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Số lượng',
			TagName: 'SLuong',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Đơn giá',
			TagName: 'DGia',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName:
				'Tỷ lệ % chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'TLCKhau',
			MaxLength: '6,4',
			DataType: 'Số',
			Constraint: 'Không Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName:
				'Số tiền chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'STCKhau',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Thành tiền (Thành tiền chưa có thuế GTGT)',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp TChat có giá trị là “4-Ghi chú/diễn giải”)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Thuế suất (Thuế suất thuế GTGT)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 17 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat',
			IsTitle: true
		},
		{
			TargetName: 'Thuế suất (Thuế suất thuế GTGT)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 17 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat'
		},
		{
			TargetName: 'Thành tiền (Thành tiền chưa có thuế GTGT)',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat'
		},
		{
			TargetName: 'Tiền thuế (Tiền thuế GTGT)',
			TagName: 'TThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true
		},
		{
			TargetName: 'Tổng tiền chưa thuế (Tổng cộng thành tiền chưa có thuế GTGT)',
			TagName: 'TgTCThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thuế (Tổng cộng tiền thuế GTGT)',
			TagName: 'TgTThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true
		},
		{
			TargetName: 'Tổng tiền chiết khấu thương mại',
			TagName: 'TTCKTMai',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng số',
			TagName: 'TgTTTBSo',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng chữ',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code',
			IsTitle: true
		},
		{
			TargetName: 'Dữ liệu QR Code',
			TagNameCheck: 'DLQRCode',
			MaxLength: 512,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName: 'Thẻ HDon\\MCCQT',
			IsTitle: true
		},
		{
			TargetName: 'Mã của cơ quan thuế',
			TagName: 'MCCQT',
			MaxLength: 23,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\MCCQT'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số người bán',
			TagName: 'Signature',
			Constraint: 'Không bắt buộc',
			PathRoot: 'Thẻ HDon\\DSCKS\\NBan'
		}
	],

	formatXMLMTTBH: [
		{
			TargetName: 'Thẻ HDon\\DLHDon\\TTChung',
			IsTitle: true,
			PathRoot: ''
		},
		{
			TargetName: 'Phiên bản XML',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên hóa đơn',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu hóa đơn',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số hóa đơn',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày lập',
			TagName: 'NLap',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Thẻ Hdon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tính chất hóa đơn',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Số (1: Thay thế, 2: Điều chỉnh)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ Hdon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Loại hóa đơn có liên quan (Loại hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục VI kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ Hdon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn có liên quan (Ký hiệu mẫu số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16 Phụ lục II kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ Hdon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu hóa đơn có liên quan (Ký hiệu hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ Hdon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Số hóa đơn có liên quan (Số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ Hdon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ngày lập hóa đơn có liên quan (Ngày lập hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'NLHDCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ Hdon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban',
			IsTitle: true,
			PathRoot:
				'Thẻ Hdon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Họ và tên người mua hàng',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Mã đơn vị quan hệ ngân sách',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Căn cước công dân',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số hộ chiếu',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tính chất',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục IV kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số thứ tự',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Mã hàng hóa, dịch vụ',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tên hàng hóa, dịch vụ',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn vị tính',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số lượng',
			TagName: 'SLuong',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn giá',
			TagName: 'DGia',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tỷ lệ % chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'TLCKhau',
			MaxLength: '6,4',
			DataType: 'Số',
			Constraint: 'Không Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Số tiền chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'STCKhau',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thành tiền',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp TChat có giá trị là “4- Ghi chú/diễn giải”)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\Ttoan',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tổng tiền chiết khấu thương mại',
			TagName: 'TTCKTMai',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Ttoan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng số',
			TagName: 'TgTTTBSo',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Ttoan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng chữ',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Ttoan'
		},
		{
			TargetName: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Ttoan'
		},
		{
			TargetName: 'Dữ liệu QR Code',
			MaxLength: 512,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code',
			TagNameCheck: 'DLQRCode'
		},
		{
			TargetName: 'Thẻ HDon\\MCCQT',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName: 'Mã của cơ quan thuế',
			TagName: 'MCCQT',
			MaxLength: 23,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\MCCQT'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\Nban',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\MCCQT'
		},
		{
			TargetName: 'Chữ ký số người bán',
			TagName: 'Signature',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\Nban'
		}
	],

	formatXMLValueAddedTicket: [
		{
			TargetName: 'Thẻ HDon\\DLHDon\\TTChung',
			IsTitle: true
		},
		{
			TargetName: 'Phiên bản XML',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên hóa đơn',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu hóa đơn',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số hóa đơn',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày lập',
			TagName: 'NLap',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Đơn vị tiền tệ',
			TagName: 'DVTTe',
			MaxLength: 3,
			DataType: 'Chuỗi ký tự (Chi tiết tại Khoản 2, Mục IV, Phần I Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tỷ giá',
			TagName: 'TGia',
			MaxLength: '7,2',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp Đơn vị tiền tệ là VND)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Hình thức thanh toán',
			TagName: 'HTTToan',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã số thuế tổ chức cung cấp giải pháp hóa đơn điện tử',
			TagName: 'MSTTCGP',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (trừ trường hợp lập hóa đơn điện tử có mã không thu tiền trên Cổng thông tin điện tử của Cơ quan thuế)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã số thuế đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'MSTDVNUNLHDon',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'TDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Địa chỉ đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'DCDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tính chất hóa đơn',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Số (1: Thay thế, 2: Điều chỉnh)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Loại hóa đơn có liên quan (Loại hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục VI kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn có liên quan (Ký hiệu mẫu số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu hóa đơn có liên quan (Ký hiệu hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Số hóa đơn có liên quan (Số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ngày lập hóa đơn có liên quan (Ngày lập hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'NLHDCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ghi chú',
			TagName: 'GChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban',
			IsTitle: true,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Fax',
			TagName: 'Fax',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Website',
			TagName: 'Website',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Mã đơn vị quan hệ ngân sách',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Mã khách hàng',
			TagName: 'MKHang',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Căn cước công dân',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số hộ chiếu',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Họ và tên người mua hàng',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tính chất',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục IV kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số thứ tự',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Mã hàng hóa, dịch vụ',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tên hàng hóa, dịch vụ',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn vị tính',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số lượng',
			TagName: 'SLuong',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn giá',
			TagName: 'DGia',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tỷ lệ % chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'TLCKhau',
			MaxLength: '6,4',
			DataType: 'Số',
			Constraint: 'Không Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Số tiền chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'STCKhau',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Thành tiền (thành tiền chưa có thuế GTGT đối với hóa đơn khác thuộc loại hóa đơn GTGT, thành tiền đối với hóa đơn khác thuộc loại hóa đơn bán hàng)',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp TChat có giá trị là “4-Ghi chú/diễn giải”)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Thuế suất (Thuế suất thuế GTGT đối với hóa đơn khác thuộc loại hóa đơn GTGT, đối với hóa đơn khác thuộc loại hóa đơn bán hàng không có thẻ này)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 17 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thuế suất (Thuế suất thuế GTGT)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 17 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Thành tiền (Thành tiền chưa có thuế GTGT)',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Tiền thuế (Tiền thuế GTGT)',
			TagName: 'TThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\NDHDon\\TToan (hóa đơn khác thuộc loại hóa đơn bán hàng thì không có thẻ này)',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Tổng tiền chưa thuế (Tổng cộng thành tiền chưa có thuế GTGT)',
			TagName: 'TgTCThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan (hóa đơn khác thuộc loại hóa đơn bán hàng thì không có thẻ này)'
		},
		{
			TargetName: 'Tổng giảm trừ không chịu thuế',
			TagName: 'TGTKCThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan (hóa đơn khác thuộc loại hóa đơn bán hàng thì không có thẻ này)'
		},
		{
			TargetName: 'Tổng tiền thuế (Tổng cộng tiền thuế GTGT)',
			TagName: 'TgTThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan (hóa đơn khác thuộc loại hóa đơn bán hàng thì không có thẻ này)'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan (hóa đơn khác thuộc loại hóa đơn bán hàng thì không có thẻ này)'
		},
		{
			TargetName: 'Tên loại phí',
			TagName: 'TLPhi',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Tiền phí',
			TagName: 'TPhi',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Tổng tiền chiết khấu thương mại',
			TagName: 'TTCKTMai',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng giảm trừ khác',
			TagName: 'TGTKhac',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng số',
			TagName: 'TgTTTBSo',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng chữ',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code',
			IsTitle: true,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName:
				'Dữ liệu QR Code (Chi tiết tại Khoản 7, Mục IV, Phần I, Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			MaxLength: 512,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName: 'Mã của cơ quan thuế (Mã của cơ quan thuế trên hóa đơn điện tử)',
			TagName: 'MCCQT',
			MaxLength: 34,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\Nban',
			IsTitle: true,
			PathRoot:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)'
		},
		{
			TargetName: 'Chữ ký số người bán',
			TagName: 'Signature',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\Nban'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\Nmua',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DSCKS\\Nban'
		},
		{
			TargetName: 'Chữ ký số người mua',
			TagName: 'Signature',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\Nmua'
		},
		{
			TargetName:
				'Với hóa đơn điện tử đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về hóa đơn điện tử và bổ sung thẻ CQT (đặt bên trong thẻ HDon\\DSCKS) chứa thông tin chữ ký số của Cơ quan thuế (ký trên thẻ HDon\\ĐLHDon, thẻ HDon\\MCCQT và thẻ HDon\\DSCKS\\CQT\\Signature\\Object)',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DSCKS\\Nmua'
		},
		{
			TargetName: 'Chữ ký số cơ quan thuế',
			TagName: 'Signature',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Với hóa đơn điện tử đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về hóa đơn điện tử và bổ sung thẻ CQT (đặt bên trong thẻ HDon\\DSCKS) chứa thông tin chữ ký số của Cơ quan thuế (ký trên thẻ HDon\\ĐLHDon, thẻ HDon\\MCCQT và thẻ HDon\\DSCKS\\CQT\\Signature\\Object)'
		}
	],

	formatXMLValueTicketRegisterCash: [
		{
			TargetName: 'Thẻ HDon\\DLHDon\\TTChung',
			IsTitle: true,
			PathRoot: ''
		},
		{
			TargetName: 'Phiên bản XML',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên hóa đơn',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu hóa đơn',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số hóa đơn',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày lập',
			TagName: 'NLap',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tính chất hóa đơn',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Số (1: Thay thế, 2: Điều chỉnh)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Loại hóa đơn có liên quan (Loại hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục VI kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn có liên quan (Ký hiệu mẫu số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16 Phụ lục II kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu hóa đơn có liên quan (Ký hiệu hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Số hóa đơn có liên quan (Số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ngày lập hóa đơn có liên quan (Ngày lập hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'NLHDCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ghi chú',
			TagName: 'GChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban',
			IsTitle: true,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua',
			IsTitle: true
		},
		{
			TargetName: 'Họ và tên người mua hàng',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Mã đơn vị quan hệ ngân sách',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Căn cước công dân',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số hộ chiếu',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tính chất',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục IV kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số thứ tự',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Mã hàng hóa, dịch vụ',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tên hàng hóa, dịch vụ',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn vị tính',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số lượng',
			TagName: 'SLuong',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn giá',
			TagName: 'DGia',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tỷ lệ % chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'TLCKhau',
			MaxLength: '6,4',
			DataType: 'Số',
			Constraint: 'Không Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Số tiền chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'STCKhau',
			MaxLength: '21,6',
			DataType: 'số',
			Constraint: 'Không Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Thành tiền (thành tiền chưa có thuế GTGT đối với hóa đơn khác thuộc loại hóa đơn GTGT, thành tiền đối với hóa đơn khác thuộc loại hóa đơn bán hàng)',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'số',
			Constraint: 'Bắt buộc (Trừ trường hợp TChat có giá trị là “4-Ghi chú/diễn giải”)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Thuế suất (Thuế suất thuế GTGT đối với hóa đơn khác thuộc loại hóa đơn GTGT, đối với hóa đơn khác thuộc loại hóa đơn bán hàng không có thẻ này)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 17 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat chứa chi tiết thông tin tổng hợp của mỗi loại thuế suất (nếu có)',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thuế suất (Thuế suất thuế GTGT)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 17 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat chứa chi tiết thông tin tổng hợp của mỗi loại thuế suất (nếu có)'
		},
		{
			TargetName: 'Thành tiền (Thành tiền chưa có thuế GTGT)',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat chứa chi tiết thông tin tổng hợp của mỗi loại thuế suất (nếu có)'
		},
		{
			TargetName: 'Tiền thuế (Tiền thuế GTGT)',
			TagName: 'TThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat chứa chi tiết thông tin tổng hợp của mỗi loại thuế suất (nếu có)'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\Ttoan',
			IsTitle: true,
			PathRoot:
				'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat chứa chi tiết thông tin tổng hợp của mỗi loại thuế suất (nếu có)'
		},
		{
			TargetName: 'Tổng tiền chưa thuế (Tổng cộng thành tiền chưa có thuế GTGT)',
			TagName: 'TgTCThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Ttoan'
		},
		{
			TargetName: 'Tổng tiền thuế (Tổng cộng tiền thuế GTGT)',
			TagName: 'TgTThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Ttoan'
		},
		{
			TargetName: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Ttoan'
		},
		{
			TargetName: 'Tổng tiền chiết khấu thương mại',
			TagName: 'TTCKTMai',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng số',
			TagName: 'TgTTTBSo',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng chữ',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code',
			IsTitle: true,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName:
				'Dữ liệu QR Code (Chi tiết tại Khoản 7, Mục IV, Phần I, Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			MaxLength: 512,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName:
				'Thẻ HDon\\MCCQT chưa thông tin mã của Cơ quan thuế trên hóa đơn điện tử được khởi tạo từ máy tính tiền.',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName: 'Mã của cơ quan thuế (Mã của cơ quan thuế trên hóa đơn điện tử khởi tạo từ máy tính tiền)',
			TagName: 'MCCQT',
			MaxLength: 23,
			DataType: 'Chuỗi ký',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\MCCQT chưa thông tin mã của Cơ quan thuế trên hóa đơn điện tử được khởi tạo từ máy tính tiền.'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\Nban',
			IsTitle: true,
			PathRoot:
				'Thẻ HDon\\MCCQT chưa thông tin mã của Cơ quan thuế trên hóa đơn điện tử được khởi tạo từ máy tính tiền.'
		},
		{
			TargetName: 'Chữ ký số người bán',
			TagName: 'Signature',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\Nban'
		}
	],

	formatXMLSaleTicket: [
		{
			TargetName: 'Thẻ HDon\\DLHDon\\TTChung',
			IsTitle: true,
			PathRoot: ''
		},
		{
			TargetName: 'Phiên bản XML',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên hóa đơn',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu hóa đơn',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số hóa đơn',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày lập',
			TagName: 'NLap',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Đơn vị tiền tệ',
			TagName: 'DVTTe',
			MaxLength: 3,
			DataType: 'Chuỗi ký tự (Chi tiết tại Khoản 2, Mục IV, Phần I Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tỷ giá',
			TagName: 'TGia',
			MaxLength: '7,2',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp Đơn vị tiền tệ là VND)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Hình thức thanh toán',
			TagName: 'HTTToan',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã số thuế tổ chức cung cấp giải pháp hóa đơn điện tử',
			TagName: 'MSTTCGP',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (trừ trường hợp lập hóa đơn điện tử có mã không thu tiền trên Cổng thông tin điện tử của Cơ quan thuế)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã số thuế đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'MSTDVNUNLHDon',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'TDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Địa chỉ đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'DCDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tính chất hóa đơn',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Số (1: Thay thế, 2: Điều chỉnh)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Loại hóa đơn có liên quan (Loại hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục VI kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn có liên quan (Ký hiệu mẫu số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 16 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu hóa đơn có liên quan (Ký hiệu hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Số hóa đơn có liên quan (Số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ngày lập hóa đơn có liên quan (Ngày lập hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'NLHDCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ghi chú',
			TagName: 'GChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban',
			IsTitle: true,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Fax',
			TagName: 'Fax',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Website',
			TagName: 'Website',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Mã đơn vị quan hệ ngân sách',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Mã khách hàng',
			TagName: 'MKHang',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Căn cước công dân',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số hộ chiếu',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Họ và tên người mua hàng',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tính chất',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục IV kèm theo Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số thứ tự',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Mã hàng hóa, dịch vụ',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tên hàng hóa, dịch vụ',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn vị tính',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số lượng',
			TagName: 'SLuong',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn giá',
			TagName: 'DGia',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tỷ lệ % chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'TLCKhau',
			MaxLength: '6,4',
			DataType: 'Số',
			Constraint: 'Không Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Số tiền chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'STCKhau',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Thành tiền (thành tiền chưa có thuế GTGT đối với hóa đơn khác thuộc loại hóa đơn GTGT, thành tiền đối với hóa đơn khác thuộc loại hóa đơn bán hàng)',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp TChat có giá trị là “4-Ghi chú/diễn giải”)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Thuế suất (Thuế suất thuế GTGT đối với hóa đơn khác thuộc loại hóa đơn GTGT, đối với hóa đơn khác thuộc loại hóa đơn bán hàng không có thẻ này)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Mục 17 Phụ lục kèm theo Quyết định số 1510/QĐ-TCT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tên loại phí',
			TagName: 'TLPhi',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Tiền phí',
			TagName: 'TPhi',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Tổng tiền chiết khấu thương mại',
			TagName: 'TTCKTMai',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng giảm trừ khác',
			TagName: 'TGTKhac',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng số',
			TagName: 'TgTTTBSo',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng chữ',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code',
			IsTitle: true,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName:
				'Dữ liệu QR Code (Chi tiết tại Khoản 7, Mục IV, Phần I, Quyết định số 1450/QĐ-TCT ngày 7/10/2021)',
			MaxLength: 512,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName: 'Mã của cơ quan thuế (Mã của cơ quan thuế trên hóa đơn điện tử)',
			TagName: 'MCCQT',
			MaxLength: 34,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\Nban',
			IsTitle: true,
			PathRoot:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)'
		},
		{
			TargetName: 'Chữ ký số người bán',
			TagName: 'Signature',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\Nban'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\Nmua',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DSCKS\\Nban'
		},
		{
			TargetName: 'Chữ ký số người mua',
			TagName: 'Signature',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\Nmua'
		},
		{
			TargetName:
				'Với hóa đơn điện tử đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về hóa đơn điện tử và bổ sung thẻ CQT (đặt bên trong thẻ HDon\\DSCKS) chứa thông tin chữ ký số của Cơ quan thuế (ký trên thẻ HDon\\ĐLHDon, thẻ HDon\\MCCQT và thẻ HDon\\DSCKS\\CQT\\Signature\\Object)',
			IsTitle: true,
			PathRoot: 'Thẻ HDon\\DSCKS\\Nmua'
		},
		{
			TargetName: 'Chữ ký số cơ quan thuế',
			TagName: 'Signature',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Với hóa đơn điện tử đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về hóa đơn điện tử và bổ sung thẻ CQT (đặt bên trong thẻ HDon\\DSCKS) chứa thông tin chữ ký số của Cơ quan thuế (ký trên thẻ HDon\\ĐLHDon, thẻ HDon\\MCCQT và thẻ HDon\\DSCKS\\CQT\\Signature\\Object)'
		}
	]
};
